import React, { useEffect, useState } from "react";
import "./consulting-field2.css";
import "./consulting-field.css";
import corporateAdvisory from "../../images/Fields/corporate-advisory.webp";
import dealAdvisory from "../../images/Fields/deal-advisory.webp";
import esgAdvisory from "../../images/Fields/esg-advisory.webp";
import fokusthemaImmobilienverwaltung from "../../images/Fields/fokusthema-immobilienverwaltung.webp";
import governanceRiskComplianceGRC from "../../images/Fields/governance-risk-compliance-grc.webp";
import BoxImage from "../../images/home/main_section_bullet--blue.svg";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const bgImages = [
	fokusthemaImmobilienverwaltung,
	dealAdvisory,
	corporateAdvisory,

	esgAdvisory,
];

const bgName = [
	"Digitalisierungs- und	Prozessberatung",
	"Unternehmenskäufe- und	verkäufe / Nachfolgelösung",
	"Strategische Beratung",
	"ESG-Beratung",
];

const bgNameFull = [];

const bgLinks = [
	"/beratungsfelder/fokusthema",
	"/beratungsfelder/deal_advisory",
	"/beratungsfelder/corporate_advisory",
	"/beratungsfelder/esg_advisory",
];

const metaK = [
	[
		"Digitalisierungsberatung und	Prozessberatung",
		"Unsere Digitalisierungs- und Prozessberatung hilft Unternehmen, durch innovative Lösungen und optimierte Prozesse ihre Effizienz und Wettbewerbsfähigkeit zu steigern.",
		"Digitalisierungsberatung, Prozessberatung, Prozessoptimierung, Effizienzsteigerung, innovative Lösungen, Wettbewerbsfähigkeit, Unternehmensberatung",
	],
	[
		"Unternehmenskäufe und Unternehmensverkäufe / Nachfolgelösung",
		"Spezialisierte Beratung für Unternehmenskäufe und -verkäufe sowie Nachfolgelösungen. Wir unterstützen Sie bei der erfolgreichen Übertragung und Integration Ihres Unternehmens.",
		"Unternehmenskäufe, Unternehmensverkäufe, Nachfolgelösung, Unternehmensübertragung, Unternehmensintegration, M&A-Beratung, Unternehmensberatung",
	],
	[
		"Strategische Beratung",
		"Unsere strategische Beratung bietet maßgeschneiderte Lösungen zur Entwicklung und Umsetzung erfolgreicher Geschäftsstrategien, um langfristiges Wachstum und Erfolg zu sichern.",
		"strategische Beratung, Geschäftsstrategie, Unternehmensstrategie, langfristiges Wachstum, Unternehmenserfolg, maßgeschneiderte Lösungen, Unternehmensberatung",
	],
	[
		"ESG Beratung",
		"Unsere ESG-Beratung unterstützt Unternehmen bei der Integration von Umwelt-, Sozial- und Governance-Faktoren in ihre Geschäftsstrategie, um nachhaltiges und verantwortungsvolles Wachstum zu fördern.",
		"ESG-Beratung, Nachhaltigkeit, Umweltfaktoren, Sozialfaktoren, Governance, verantwortungsvolles Wachstum, Unternehmensstrategie, Unternehmensberatung",
	],
];
export default function ConsultingFields() {
	const slides = ["red", "blue", "green", "pink"];
	const [currentSlide, setCurrentSlide] = useState(0);
	const navigate = useNavigate();

	const navigateToLink = () => {};

	const [mainBG, setMainBG] = useState(corporateAdvisory);
	const [secBg, setSecBg] = useState(dealAdvisory);
	const changeBG = (e, image, index) => {
		const mainImages = document.querySelector(".image-stack-new");
		const iconImage = document.querySelector(".image-consult");

		mainImages.style.opacity = 0;

		setSecBg(image);
		mainImages.style.opacity = 1;
	};

	const goToPage = (index) => {
		navigate(bgLinks[index]);
	};

	return (
		<div className="main-fields">
			<div className="field-hd">
				<h2>Beratungsfelder für die Immobilienwirtschaft</h2>
				<div className="typeset">
					<div className="header-icon">
						<img src={BoxImage} alt="BoxIcon" />
					</div>
					<div className="header-desc font-text">
						<p>
							Profitieren Sie von unserer jahrelangen Erfahrung in der
							Unternehmensberatung. Unsere Dienstleistungen sind speziell auf
							die Bedürfnisse der Immobilienwirtschaft zugeschnitten.
						</p>
					</div>
				</div>
			</div>
			<div className="fields-preview2">
				<div
					className="image-stack-new"
					style={{ backgroundImage: `url(${secBg})` }}
				></div>
				<div className="section-name-images">
					{bgImages.map((regionImage, index) => (
						<div
							key={`ml-${index}-new`}
							id={`ml-${index}-new`}
							className={`image-wrapper-new ml-${index}-new`}
							onMouseEnter={(e) => changeBG(e, regionImage, index)}
							onClick={(e) => goToPage(index)}
						>
							<img
								className={"image-consolut image-flip-" + index}
								src={regionImage}
							/>
							<span>{bgName[index]}</span>
							<div className="more-consult">
								<Link to={bgLinks[index]} className=" icon-button">
									<span>mehr erfahren</span>
								</Link>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}
